/**
 * -----------------------------------------------------------------------------
 * It renders a trash icon.
 */
export function TrashIcon() {
  return (
    <svg fill="none" height={20} width={20} xmlns="http://www.w3.org/2000/svg">
      <path
        className="stroke-gray-950"
        d="M16.875 4.375H3.125M6.875 1.875h6.25M15.625 4.375V16.25a.624.624 0 0 1-.625.625H5a.625.625 0 0 1-.625-.625V4.375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
